<template>
    <div>
        <v-dialog
            v-model="isOpenOrders"
            persistent
            max-width="1200px"
            transition="dialog-top-transition"
        >
            <v-card>
                <v-row
                    v-if="e1 == 1"
                    elevation="0"
                    class="d-flex flex-row px-4 pt-4"
                    style="width: 100%;"
                >
                    <v-col
                        md="9"
                        class="font-weight-light"
                        style="font-size: 2.1rem !important"
                    >
                        <v-icon size="50">mdi-package-variant</v-icon>
                        Órdenes
                    </v-col>
                    <v-col md="3" class="d-flex justify-end align-self-center">
                        <v-dialog
                            v-if="cliente"
                            v-model="dialog"
                            width="400"
                        >
                            <template
                                v-slot:activator="{ on, attrs }"
                            >
                                <v-btn
                                    depressed
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>
                                        mdi-information-variant
                                    </v-icon>
                                    Información del cliente
                                </v-btn>
                            </template>
                            <v-card class="pt-4">
                                <div class="">
                                    <v-row class="my-n3">
                                        <v-col md="6" class="d-flex justify-center">
                                            <v-icon size="30" left class="mr-3">
                                                mdi-account-circle-outline
                                            </v-icon>
                                        </v-col>
                                        <v-col md="6" class="d-flex justify-start ml-md-n6">
                                            
                                            {{ cliente.titular }}
                                        </v-col>
                                    </v-row>

                                    <v-row class="my-n3">
                                        <v-col md="6" class="d-flex justify-center">
                                            <v-icon size="30" left class="mr-3">
                                                mdi-passport
                                            </v-icon>
                                        </v-col>
                                        <v-col md="6" class="d-flex justify-start ml-md-n6">
                                            
                                            {{
                                                cliente.documentation[0]
                                                    .identificationId
                                            }}
                                        </v-col>
                                    </v-row>

                                    <v-row class="my-n3">
                                        <v-col md="6" class="d-flex justify-center">
                                            <v-icon size="30" left>
                                                mdi-home
                                            </v-icon>
                                        </v-col>
                                        <v-col md="6" class="d-flex justify-start ml-md-n6">
                                            
                                            {{ typeUser[cliente.tipo] }}
                                        </v-col>
                                    </v-row>

                                    <v-row class="my-n3">
                                        <v-col md="6" class="d-flex justify-center">
                                            <v-icon size="30" left>
                                                mdi-{{
                                                    stateUser[
                                                        cliente.estado
                                                    ]['icon']
                                                }}
                                            </v-icon>
                                        </v-col>
                                        <v-col md="6" class="d-flex justify-start ml-md-n6">
                                            
                                            {{
                                                stateUser[
                                                    cliente.estado
                                                ]['nombre']
                                            }}
                                        </v-col>
                                    </v-row>

                                    <v-row class="my-n3">
                                        <v-col md="6" class="d-flex justify-center">
                                            <v-icon size="30" left>
                                                mdi-calendar-start
                                            </v-icon>
                                        </v-col>
                                        <v-col md="6" class="d-flex justify-start ml-md-n6">
                                            Activo desde: {{
                                                cliente.activo_desde
                                                    ? formatDate(
                                                          cliente.activo_desde
                                                      )
                                                    : '-'
                                            }}
                                        </v-col>
                                    </v-row>

                                </div>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="error"
                                        text
                                        @click="dialog = false"
                                    >
                                        Cerrar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-col md="3">
                </v-row>

                <v-stepper v-model="e1" flat>
                    <v-stepper-items>
                        <v-stepper-content step="1" class="pt-0 px-0">
                            <v-card-text class="pa-4">
                                <!-- Paquetes de la propia oferta -->
                                <v-row v-if="packages" class="mt-1">
                                    <v-col cols="12">
                                        <v-card
                                            elevation="0"
                                        >
                                            <v-expansion-panels
                                                accordion
                                                flat
                                                focusable
                                                tile
                                            >
                                                <v-expansion-panel>
                                                    <v-expansion-panel-header ripple>
                                                        <strong
                                                            class="
                                                                text-button
                                                            "
                                                            style="
                                                                font-size: 1.3rem !important;
                                                            "
                                                            >Paquetes de la
                                                            oferta</strong
                                                        >
                                                        <strong
                                                            v-if="updatedOn"
                                                            class="
                                                                text-right
                                                                mr-2
                                                            "
                                                        >
                                                            <h3 class="font-weight-light">{{
                                                                formatDateLarge(
                                                                    updatedOn
                                                                )
                                                            }}</h3>
                                                        </strong>
                                                    </v-expansion-panel-header>
                                                    <v-expansion-panel-content>
                                                        <v-divider
                                                            class="test"
                                                        ></v-divider>
                                                        <v-data-table
                                                            :headers="
                                                                headersPackages
                                                            "
                                                            :items="
                                                                packagesSort
                                                            "
                                                            :item-class="
                                                                itemRowBackgroundPackage
                                                            "
                                                            class="mt-4"
                                                            hide-default-footer
                                                            :loading="
                                                                updateOrder
                                                            "
                                                        >
                                                            <template
                                                                v-slot:item.tipoVenta="{
                                                                    item,
                                                                }"
                                                            >
                                                                {{
                                                                    item.tipoVenta
                                                                        ? item.tipoVenta ==
                                                                          'PORTA'
                                                                            ? 'Portabilidad'
                                                                            : capitalize(
                                                                                  item.tipoVenta.replace(
                                                                                      '_',
                                                                                      ' '
                                                                                  )
                                                                              )
                                                                        : ''
                                                                }}
                                                            </template>
                                                            <template
                                                                v-slot:item.tarifa.segment="{
                                                                    item,
                                                                }"
                                                            >
                                                                {{
                                                                    capitalize(
                                                                        item
                                                                            .tarifa
                                                                            .segment
                                                                    )
                                                                }}
                                                            </template>
                                                            <template
                                                                v-slot:item.lineasAsociadas="{
                                                                    item,
                                                                }"
                                                            >
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        justify-center
                                                                    "
                                                                >
                                                                    <v-menu
                                                                        v-if="
                                                                            item
                                                                                .lineasAsociadas
                                                                                .length >
                                                                            1
                                                                        "
                                                                        offset-y
                                                                    >
                                                                        <template
                                                                            v-slot:activator="{
                                                                                on,
                                                                                attrs,
                                                                            }"
                                                                        >
                                                                            <v-icon
                                                                                color="primary"
                                                                                v-bind="
                                                                                    attrs
                                                                                "
                                                                                v-on="
                                                                                    on
                                                                                "
                                                                            >
                                                                                mdi-phone-plus
                                                                            </v-icon>
                                                                        </template>
                                                                        <v-list>
                                                                            <v-list-item
                                                                                v-for="(
                                                                                    tlf,
                                                                                    index
                                                                                ) in item.lineasAsociadas"
                                                                                :key="
                                                                                    index
                                                                                "
                                                                            >
                                                                                <v-list-item-title
                                                                                    >{{
                                                                                        tlf
                                                                                    }}</v-list-item-title
                                                                                >
                                                                            </v-list-item>
                                                                        </v-list>
                                                                    </v-menu>
                                                                    <div v-else>
                                                                        {{
                                                                            item.lineasAsociadas.toString()
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template
                                                                v-slot:item.seguro="{
                                                                    item,
                                                                }"
                                                            >
                                                                {{
                                                                    item.seguro
                                                                        ? item
                                                                              .seguro
                                                                              .name
                                                                        : ''
                                                                }}
                                                            </template>
                                                            <template
                                                                v-slot:item.crossSell="{
                                                                    item,
                                                                }"
                                                            >
                                                                {{
                                                                    item.crossSell
                                                                        ? 'Si'
                                                                        : ''
                                                                }}
                                                            </template>
                                                            <template
                                                                v-slot:item.state="{
                                                                    item,
                                                                }"
                                                            >
                                                                {{
                                                                    item.tipoLinea !=
                                                                    'LINEA_ADICIONAL_SVA'
                                                                        ? item.additionalinfo && item
                                                                              .additionalinfo
                                                                              .state
                                                                            ? capitalize(
                                                                                  item
                                                                                      .additionalinfo
                                                                                      .state
                                                                              )
                                                                            : 'No encontrado'
                                                                        : ''
                                                                }}
                                                            </template>
                                                            <template
                                                                v-slot:item.actions_detail_order="{
                                                                    item,
                                                                }"
                                                            >
                                                                <v-icon
                                                                    v-if="item.additionalinfo"
                                                                    :disabled="
                                                                        isLoadingOrder
                                                                    "
                                                                    color="primary"
                                                                    @click="
                                                                        fetchOrderDetailOwn(item.additionalinfo, item.id)
                                                                    "
                                                                >
                                                                    mdi-arrow-right-bottom
                                                                </v-icon>
                                                            </template>
                                                        </v-data-table>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-card>
                                    </v-col>
                                </v-row>

                                <!-- Ordenes actuales -->
                                <v-row
                                    v-if="ordenes && ordenes.ACTUALES"
                                    class="mt-1"
                                >
                                    <v-col cols="12">
                                        <v-card
                                            elevation="4"
                                            style="border-radius: 10px"
                                        >
                                            <v-expansion-panels
                                                flat
                                                tile
                                                focusable
                                                multiple
                                                v-model="panel"
                                            >
                                                <v-expansion-panel>
                                                    <v-expansion-panel-header
                                                        style="
                                                            background-color: #f2f4fc;
                                                        "
                                                    >
                                                        <strong
                                                            class="
                                                                text-button
                                                            "
                                                            style="
                                                                font-size: 1.3rem !important;
                                                            "
                                                            >Órdenes
                                                            actuales</strong
                                                        >
                                                    </v-expansion-panel-header>
                                                    <v-expansion-panel-content>
                                                        <v-divider
                                                            class="test"
                                                        ></v-divider>
                                                        <v-data-table
                                                            :headers="[
                                                                {
                                                                    text: 'SFID',
                                                                    align: 'center',
                                                                    sortable: false,
                                                                    value: 'sfid',
                                                                },
                                                                ...headers,
                                                            ]"
                                                            :items="
                                                                getSortOrdersActuals
                                                            "
                                                            :item-class="
                                                                itemRowBackground
                                                            "
                                                            class="mt-4"
                                                            :loading="
                                                                isLoadingOrder
                                                            "
                                                            hide-default-footer
                                                        >
                                                            <template
                                                                v-slot:item.sfid="{
                                                                    item,
                                                                }"
                                                            >
                                                                <span
                                                                    class="
                                                                        font-weight-bold
                                                                    "
                                                                    >{{
                                                                        item.sfid
                                                                    }}</span
                                                                >
                                                            </template>
                                                            <template
                                                                v-slot:item.superStatus="{
                                                                    item,
                                                                }"
                                                            >
                                                                <v-tooltip
                                                                    right
                                                                >
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs,
                                                                        }"
                                                                    >
                                                                        <div
                                                                            v-on="
                                                                                on
                                                                            "
                                                                        >
                                                                            <v-chip
                                                                                label
                                                                                v-bind="
                                                                                    attrs
                                                                                "
                                                                                class="
                                                                                    ml-1
                                                                                    overline
                                                                                "
                                                                                :color="
                                                                                    stateUser[
                                                                                        item
                                                                                            .superStatus
                                                                                    ][
                                                                                        'color'
                                                                                    ]
                                                                                "
                                                                                medium
                                                                            >
                                                                                <v-icon
                                                                                    left
                                                                                >
                                                                                    mdi-{{
                                                                                        stateUser[
                                                                                            item
                                                                                                .superStatus
                                                                                        ][
                                                                                            'icon'
                                                                                        ]
                                                                                    }}
                                                                                </v-icon>
                                                                                {{
                                                                                    stateUser[
                                                                                        item
                                                                                            .superStatus
                                                                                    ][
                                                                                        'nombre'
                                                                                    ]
                                                                                }}
                                                                            </v-chip>
                                                                        </div>
                                                                    </template>
                                                                    {{
                                                                        `(${
                                                                            item
                                                                                .status
                                                                                .code
                                                                        }) ${
                                                                            item
                                                                                .status
                                                                                .description
                                                                        } ${
                                                                            item.statusOt
                                                                                ? `- ${item.statusOt}`
                                                                                : ''
                                                                        }`
                                                                    }}
                                                                </v-tooltip>
                                                            </template>
                                                            <template
                                                                v-slot:item.orderDate="{
                                                                    item,
                                                                }"
                                                            >
                                                                {{
                                                                    formatDateLarge(
                                                                        item.orderDate
                                                                    )
                                                                }}
                                                            </template>
                                                            <template
                                                                v-slot:item.actions_detail_order="{
                                                                    item,
                                                                }"
                                                            >
                                                                <v-icon
                                                                    v-if="!paqueteOfferhasOrderId(item.id)"
                                                                    :disabled="
                                                                        isLoadingOrder
                                                                    "
                                                                    color="primary"
                                                                    @click="
                                                                        fetchOrderDetail(
                                                                            item.id
                                                                        )
                                                                    "
                                                                >
                                                                    mdi-arrow-right-bottom
                                                                </v-icon>
                                                            </template>
                                                        </v-data-table>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <!-- Historial de ordenes -->
                                <v-row class="mt-1">
                                    <v-col cols="12">
                                        <v-card
                                            elevation="0"
                                        >
                                            <v-expansion-panels
                                                accordion
                                                flat
                                                focusable
                                                tile
                                            >
                                                <v-expansion-panel>
                                                    <v-expansion-panel-header
                                                    >
                                                        <strong
                                                            class="
                                                                text-button
                                                                
                                                            "
                                                            style="
                                                                font-size: 1.3rem !important;
                                                            "
                                                            >Historial de
                                                            ordenes</strong
                                                        >
                                                    </v-expansion-panel-header>
                                                    <v-expansion-panel-content>
                                                        <v-divider
                                                            class="test"
                                                        ></v-divider>
                                                        <v-data-table
                                                            :headers="headers"
                                                            :items="
                                                                getSortOrdersHistory
                                                            "
                                                            :item-class="
                                                                itemRowBackground
                                                            "
                                                            class="mt-4"
                                                            :loading="
                                                                isLoadingOrder
                                                            "
                                                            hide-default-footer
                                                        >
                                                            <template
                                                                v-slot:item.superStatus="{
                                                                    item,
                                                                }"
                                                            >
                                                                <v-tooltip
                                                                    right
                                                                >
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs,
                                                                        }"
                                                                    >
                                                                        <div
                                                                            v-on="
                                                                                on
                                                                            "
                                                                        >
                                                                            <v-chip
                                                                                label
                                                                                v-bind="
                                                                                    attrs
                                                                                "
                                                                                class="
                                                                                    ml-1
                                                                                    overline
                                                                                "
                                                                                :color="
                                                                                    stateUser[
                                                                                        item
                                                                                            .superStatus
                                                                                    ][
                                                                                        'color'
                                                                                    ]
                                                                                "
                                                                                medium
                                                                            >
                                                                                <v-icon
                                                                                    left
                                                                                >
                                                                                    mdi-{{
                                                                                        stateUser[
                                                                                            item
                                                                                                .superStatus
                                                                                        ][
                                                                                            'icon'
                                                                                        ]
                                                                                    }}
                                                                                </v-icon>
                                                                                {{
                                                                                    stateUser[
                                                                                        item
                                                                                            .superStatus
                                                                                    ][
                                                                                        'nombre'
                                                                                    ]
                                                                                }}
                                                                            </v-chip>
                                                                        </div>
                                                                    </template>
                                                                    {{
                                                                        `(${
                                                                            item
                                                                                .status
                                                                                .code
                                                                        }) ${
                                                                            item
                                                                                .status
                                                                                .description
                                                                        } ${
                                                                            item.statusOt
                                                                                ? `- ${item.statusOt}`
                                                                                : ''
                                                                        }`
                                                                    }}
                                                                </v-tooltip>
                                                            </template>
                                                            <template
                                                                v-slot:item.orderDate="{
                                                                    item,
                                                                }"
                                                            >
                                                                {{
                                                                    formatDateLarge(
                                                                        item.orderDate
                                                                    )
                                                                }}
                                                            </template>
                                                            <template
                                                                v-slot:item.actions_detail_order="{
                                                                    item,
                                                                }"
                                                            >
                                                                <v-icon
                                                                    v-if="!paqueteOfferhasOrderId(item.id)"
                                                                    :disabled="
                                                                        isLoadingOrder
                                                                    "
                                                                    color="primary"
                                                                    @click="
                                                                        fetchOrderDetail(
                                                                            item.id
                                                                        )
                                                                    "
                                                                >
                                                                    mdi-arrow-right-bottom
                                                                </v-icon>
                                                            </template>
                                                        </v-data-table>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-stepper-content>
                        <v-stepper-content step="2" class="pt-0 px-0">
                            <OrdersViewDetail />
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>

                <div class="d-flex justify-end pa-2">
                    <v-btn
                        v-if="e1 == 2"
                        text
                        color="warning"
                        @click="goFirstStep()"
                        :disabled="isLoadingContract"
                        class="mr-2"
                    >
                        Volver
                    </v-btn>
                    <v-btn
                        :disabled="isLoadingOrder || isLoadingContract"
                        text
                        color="red"
                        @click="closeDialog"
                        class="mr-2"
                    >
                        Cerrar
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatDateLarge, formatDate } from '@/util/libUtil.js';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';
import OrdersViewDetail from '@/components/ComercialTeletrabajo/DetailedView/OrdersViewDetail.vue';

export default {
    name: 'OrdersView',
    components: {
        LoadingSkeleton,
        OrdersViewDetail,
    },
    data: () => ({
        panel: [0],
        e1: 1,
        dialog: false,
        typeUser: {
            'PRO-SOHO-COMPANY': 'PRO COMPAÑIA',
            'PRO-SOHO-AUTONOMO': 'PRO AUTONOMO',
            CONSUMER: 'PARTICULAR',
        },
        headers: [
            {
                text: 'Pedido',
                value: 'id',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Suscripción',
                value: 'productNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Estado',
                value: 'superStatus',
                align: 'center',
                sortable: false,
            },
            { text: 'Tipo', value: 'type', align: 'center', sortable: false },
            {
                text: 'Fecha',
                value: 'orderDate',
                align: 'center',
                sortable: false,
            },
            {
                text: '+ Info',
                value: 'actions_detail_order',
                align: 'center',
                sortable: false,
            },
        ],
        headersPackages: [
            {
                text: 'Nombre',
                value: 'tarifa.name',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Segmento',
                value: 'tarifa.segment',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Lineas asociadas',
                value: 'lineasAsociadas',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Tipo de venta',
                value: 'tipoVenta',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Dispositivo',
                value: 'cacharro.name',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Seguro',
                value: 'seguro',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Cross sell',
                value: 'crossSell',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Estado',
                value: 'state',
                align: 'center',
                sortable: false,
            },
            {
                text: '+ Info',
                value: 'actions_detail_order',
                align: 'center',
                sortable: false,
            },
        ],
    }),
    props: {
        packages: null,
        updatedOn: null,
    },
    methods: {
        formatDateLarge,
        formatDate,
        capitalize(word) {
            const lower = word.toLowerCase();
            return word.charAt(0).toUpperCase() + lower.slice(1);
        },
        paqueteOfferhasOrderId(id) {
            if (this.packages) {
                return this.packages.find(
                    (paquete) => paquete.additionalinfo?.orderId == id
                );
            }
        },
        itemRowBackground: function (item) {
            let color = 'azul';

            if (
                item.superStatus == 'active' ||
                item.superStatus == 'delivered'
            ) {
                color = 'verde';
            } else if (item.superStatus == 'fly') {
                color = 'amarillo';
            } else if (item.superStatus == 'cancelled') {
                color = 'rojo';
            }

            return color;
        },
        itemRowBackgroundPackage: function (item) {
            let color = 'azul';

            if (item.additionalinfo?.state == 'ACTIVO') {
                color = 'verde';
            } else if (item.additionalinfo?.state == 'VUELO') {
                color = 'amarillo';
            } else if (item.additionalinfo?.state == 'CANCELADO') {
                color = 'rojo';
            }

            return color;
        },
        goFirstStep() {
            this.e1 = 1;
            this.$store.commit('orders/orderData', null);
            this.$store.commit('orders/orderDataDetail', null);
        },
        closeDialog() {
            this.$store.commit('orders/isOpenOrders', false);
            // this.$store.commit('teletrabajo/CompleteViewTtFormDetailsForm', {});
            // this.packages = null;
            // this.fechaContacto = null;
            this.goFirstStep();
        },
        fetchOrderDetail(id) {
            this.$store.dispatch('orders/getOrderMoreDetail', id);
            this.$store.dispatch('orders/getOrderDetail', id).then(() => {
                setTimeout(() => {
                    this.e1 = 2;
                }, 100);
            });
        },
        getPackageStatusFromStateCode(stateCode) {
            return this.stateUser[this.orderNumberToState[stateCode]]
                .packageStatus;
        },
        fetchOrderDetailOwn(packageItem, packageId) {
            this.$store.dispatch(
                'orders/getOrderMoreDetail',
                packageItem.orderId
            );
            this.$store
                .dispatch('orders/getOrderDetail', packageItem.orderId)
                .then(() => {
                    const stateOrder = this.getPackageStatusFromStateCode(
                        this.order.orderData.state
                    );

                    if (
                        stateOrder != packageItem.state ||
                        this.order.orderData.id != packageItem.orderId ||
                        this.order.orderData.sfid != packageItem.sfid
                    ) {
                        const packageStatusItem = {
                            state: stateOrder,
                            orderId: this.order.orderData.id,
                            actualOrderId: packageItem.id,
                            sfid: this.order.orderData.sfid,
                            paquete: packageId,
                        };
                        this.$store
                            .dispatch(
                                'orders/updateAdditionalInfo',
                                packageStatusItem
                            )
                            .then((resp) => {
                                this.packages.find(
                                    (item1) => item1.id === packageId
                                ).additionalinfo = resp;
                            });
                    }

                    setTimeout(() => {
                        this.e1 = 2;
                    }, 100);
                });
        },
        inDays: function (d1, d2) {
            var t2 = d2.getTime();
            var t1 = d1.getTime();

            return Math.floor((t2 - t1) / (24 * 3600 * 1000));
        },
        inHours: function (d1, d2) {
            return Math.abs(d1 - d2) / 36e5;
        },
        getOrderMoreNear(orders) {
            let dateOffer = new Date(this.updatedOn);
            const hoursInMonth = 31 * 24;
            let minOrder = null;
            let minValue = Infinity;
            //  The orders are sorted by date then, the first one is the nearest in theory, check
            let firstOrden = orders.shift();
            if (firstOrden) {
                let dateFirstOrder = new Date(firstOrden.orderDate);
                let diff = this.inHours(dateOffer, dateFirstOrder);
                if (diff <= hoursInMonth) {
                    minValue = diff;
                    minOrder = firstOrden;
                }
            }

            if (!minOrder) {
                orders.forEach((order) => {
                    let dateOrder = new Date(order.orderDate);
                    let diff = this.inHours(dateOffer, dateOrder);
                    if (diff <= hoursInMonth && diff < minValue) {
                        minValue = diff;
                        minOrder = order;
                    }
                });
            }

            return minOrder;
        },
    },
    computed: {
        packagesSort() {
            if (this.packages) {
                return [...this.packages].sort((a, b) => {
                    if (a.tipoLinea > b.tipoLinea) {
                        return -1;
                    }
                    if (a.tipoLinea < b.tipoLinea) {
                        return 1;
                    }
                    return 0;
                });
            }
        },
        getSortOrdersActuals() {
            if (this.ordenes) {
                return this.ordenes.ACTUALES.sort((a, b) => {
                    return a.orderDate.localeCompare(b.orderDate);
                }).reverse();
            }
        },
        getSortOrdersHistory() {
            if (this.ordenes) {
                return this.ordenes.HISTORICO.sort((a, b) => {
                    return a.orderDate.localeCompare(b.orderDate);
                }).reverse();
            }
        },
        getPackagesNoSVA() {
            return this.packages.filter(
                (item) => item.tipoLinea !== 'LINEA_ADICIONAL_SVA'
            );
        },
        isOpenOrders: {
            get: function () {
                return this.$store.state.orders.isOpenOrders;
            },
            set: function (val) {
                this.$store.commit('orders/isOpenOrders', val);
            },
        },
        ...mapState('teletrabajo', {
            ordenes: (state) => state.CompleteViewTtForm.details.form.ORDENES,
            cliente: (state) =>
                state.CompleteViewTtForm.details.form.INFO_CLIENTE,
        }),
        ...mapState('orders', {
            order: (state) => state.order,
            isOpenOrders: (state) => state.isOpenOrders,
            isLoadingOrder: (state) => state.order.isLoadingOrder,
            isLoadingContract: (state) => state.contract.isLoadingContract,
            updateOrder: (state) => state.updateOrder,
            stateUser: (state) => state.stateUser,
            orderNumberToState: (state) => state.orderNumberToState,
        }),
    },
    watch: {
        isOpenOrders: {
            immediate: true,
            handler(val) {
                if (val) {
                    if (this.packages) {
                        let packageStatus = [];
                        // console.log(this.getPackagesNoSVA);
                        // console.log(this.getSortOrdersHistory);
                        this.getPackagesNoSVA.forEach((item) => {
                            let orders = this.getSortOrdersHistory.filter(
                                (order) =>
                                    item.lineasAsociadas.find(
                                        (linea) => order.msisdn === linea
                                    )
                            );
                            let order = this.getOrderMoreNear(orders);

                            if (order) {
                                // Get sfid if exists in ORDENES.ACTUALES
                                order['sfid'] = null;
                                if (this.ordenes.ACTUALES) {
                                    this.ordenes.ACTUALES.find((item) => {
                                        if (item.id === order.id) {
                                            order['sfid'] = item.sfid;
                                        }
                                    });
                                }

                                // Don't update the status if is the same
                                if (
                                    this.stateUser[order.superStatus]
                                        .packageStatus !=
                                        item.additionalinfo?.state ||
                                    item.additionalinfo?.orderId != order.id ||
                                    item.additionalinfo?.sfid != order.sfid
                                ) {
                                    const packageStatusItem = {
                                        state: this.stateUser[order.superStatus]
                                            .packageStatus,
                                        orderId: order.id,
                                        sfid: order.sfid,
                                        paquete: item.id,
                                        update: item.additionalinfo != null,
                                    };
                                    if (item.additionalinfo != null) {
                                        packageStatusItem['actualOrderId'] =
                                            item.additionalinfo.id;
                                    }
                                    packageStatus.push(packageStatusItem);
                                }
                            }
                        });
                        // Check if packageStatus is not empty
                        // console.log(packageStatus);
                        if (packageStatus.length) {
                            this.$store.commit('orders/updateOrder', true);
                            packageStatus.forEach((item) => {
                                // Return the new state save in package, set in package.
                                // pop update from item
                                let update = item.update;
                                delete item.update;

                                if (update) {
                                    this.$store
                                        .dispatch(
                                            'orders/updateAdditionalInfo',
                                            item
                                        )
                                        .then((resp) => {
                                            this.packages.find(
                                                (item1) =>
                                                    item1.id === item.paquete
                                            ).additionalinfo = resp;
                                        });
                                } else {
                                    this.$store
                                        .dispatch(
                                            'orders/createAdditionalInfo',
                                            item
                                        )
                                        .then((resp) => {
                                            this.packages.find(
                                                (item1) =>
                                                    item1.id === item.paquete
                                            ).additionalinfo = resp;
                                        });
                                }
                            });
                            setTimeout(() => {
                                this.$store.commit('orders/updateOrder', false);
                            }, 500);
                            this.$store.commit('orders/isUpdatedOrder', true);
                        }
                    }
                }
            },
        },
    },
};
</script>
<style scoped>
.test {
    border-width: 1px !important;
    border-color: #e0e0e0 !important;
    height: 100%;
}

.verde {
    background-color: rgb(206, 255, 206);
}

.rojo {
    background-color: rgb(255, 191, 191);
}

.naranja {
    background-color: rgb(255, 221, 159);
}

.amarillo {
    background-color: rgb(255, 253, 161);
}

.azul {
    background-color: #cad3eb;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
    padding: 0 !important;
}

.test2 {
    border-style: dotted;
    border-width: 1px !important;
    border-color: #e0e0e0 !important;
    height: 100%;
}

.bg-gray {
    border-style: dotted;
    border-width: 2px !important;
    border-color: #7e7e7e;
    background-color: #e0e0e0;
    margin-right: 5px;
    margin-left: 5px;
    padding: 3px;
}
</style>